import axios from 'axios';

export default {
  async getMenu({ commit }, data) {
    try {
      const response = await axios.get('/role/menu');
      commit('GET_ROLE_MENU', response.data);
      return response;
    } catch (e) {
      return e;
    }
  },
  async getTree({ commit }, data) {
    try {
      const response = await axios.get('/menu/tree');
      commit('GET_MENU_TREE', response.data);
      return response;
    } catch (e) {
      return e;
    }
  },
  async getParent({ commit }, data) {
    try {
      const response = await axios.get('/menu/parent');
      commit('GET_MENU_PARENT', response.data);
      return response;
    } catch (e) {
      return e;
    }
  },
};
